import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import * as routes from 'app/routes';
import { logout } from 'auth/actions';
import { getUser } from 'reducers';

import Menu from 'common/Menu';
import Link from 'common/Link';

import styles from './MainMenu.module.css';

export const MainMenu = ({ user }) => {
  const preventDefaultIfNotUser = e => {
    if (!user) {
      e.preventDefault();
    }
  }

  return (
    <Menu>
      <Link className={cn({ [styles.disabled]: !user })} onClick={preventDefaultIfNotUser} to={routes.account()}>
        Account Settings
      </Link>
      <Link className={cn({ [styles.disabled]: !user })} onClick={preventDefaultIfNotUser} to={routes.billing()}>
        Billing
      </Link>
      {user &&
        <Link to={logout()}>
          Sign Out
        </Link>
      }
    </Menu>
  )
};

const mapStateToProps = (state) => ({
  user: getUser(state)
});

export default connect(
  mapStateToProps,
)(MainMenu);
